export const HEADER_TENANT_ID = "X-Tenant-Id";
export const HEADER_ORGANIZATION_ID = "X-Organization-Id";
export const HEADER_COMPANY_ID = "X-Company-Id";
export const HEADER_EMPLOYEE_ID = "X-Employee-Id";
export const HEADER_AUTHORIZATION = "Authorization";
export const HEADER_CORRELATION_ID = "X-Correlation-Id";
